/******/ (() => { // webpackBootstrap
class CartUpdate extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('textarea');
    this.status = this.querySelector('[data-cart-update-status]');
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-update'});
  }

  async save() {
    if (!this.input) return false;

    const body = this.fetchBody(this.input.name, this.input.value);
    if (!body) return false;

    this.setBusy(true);
    this.announce(this.dataset.savingMessage || 'Saving cart note.');
    try {
      const response = await fetch(window.routes.cart_update_url, {
        ...this.fetchConfig(),
        body: JSON.stringify(body),
        keepalive: true,
      });
      const responseText = await response.text();
      const parsedResponse = responseText ? JSON.parse(responseText) : {};
      if (!response.ok || parsedResponse.errors || parsedResponse.status >= 400) {
        throw new Error(parsedResponse.description || parsedResponse.message || this.dataset.errorMessage);
      }

      this.announce(this.dataset.successMessage || 'Cart note saved.');
      return true;
    } catch (error) {
      this.announce(this.dataset.errorMessage || 'The cart note could not be saved. Please try again.', true);
      return false;
    } finally {
      this.setBusy(false);
    }
  }

  fetchBody(name, value) {
    if (name === 'note') return { note: value };

    const match = name.match(/^attributes\[([^\]]+)\]$/);
    if (match) return { attributes: { [match[1]]: value } };
    return null;
  }

  fetchConfig() {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    };
  }

  setBusy(isBusy) {
    this.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    this.input.readOnly = isBusy;
    this.closest('cart-update-modal')?.setSaveBusy(isBusy);
  }

  announce(message, isError = false) {
    if (!this.status || !message) return;
    this.status.textContent = '';
    this.status.setAttribute('role', isError ? 'alert' : 'status');
    window.requestAnimationFrame(() => {
      this.status.textContent = message;
    });
  }
}

customElements.define('cart-update', CartUpdate);
/******/ })()
;
